import { FC, ReactNode } from 'react';
import { InfoViewDetailsDataProps, InfoViewImageDataProps } from './types';
import { InfoViewContainer } from './InfoViewModal.styles';
import DialogInfo from 'components/DialogInfo/DialogInfo';
import InfoViewDetails from './InfoViewDetails/InfoViewDetails';
import InfoViewImage from './InfoViewImage/InfoViewImage';

type InfoViewModalProps = {
  openDialog: boolean;
  handleDialog: VoidFunction;
  infoViewDetailsData: InfoViewDetailsDataProps[];
  infoViewImageData: InfoViewImageDataProps[];
  title: string;
  headerIcon?: ReactNode;
};

const InfoViewModal: FC<InfoViewModalProps> = ({
  openDialog,
  handleDialog,
  infoViewDetailsData,
  infoViewImageData,
  title = '',
  headerIcon,
}) => {
  return (
    <DialogInfo
      customStyles={{ maxWidth: '800px' }}
      title={`View ${title}`}
      openDialog={openDialog}
      handleDialog={handleDialog}
      headerIcon={headerIcon}
    >
      <InfoViewContainer>
        <InfoViewDetails infoViewDetailsData={infoViewDetailsData} />
        <InfoViewImage infoViewImageData={infoViewImageData} />
      </InfoViewContainer>
    </DialogInfo>
  );
};

export default InfoViewModal;
